export const API_BASE_URL = "https://api.watchanime.dev/v1";
export const API_BASE_URL_V2 = "https://api.watchanime.dev/v2/graphql";

export const NOTIFICATION_BASE_URL = "https://notifications.watchanime.dev";
export const NOTIFICATION_BASE_URL_V2 = "https://notifications.watchanime.dev/v2/graphql";

export const OAUTH_BASE_URL = "https://oauth.watchanime.dev";

export const GOGO_DOWNLOAD_LINK = "https://s3taku.com";
export const STATIC_BUCKET_URL = "https://webstatic.watchanime.dev/watchanime-static";
export const AUTH_BASE_URL = "https://auth.watchanime.dev";

export const IS_CHRISTMAS_ENABLED = new Date().getMonth() === 11;
